<template>
<div class="myMassageBox" @click="hideBg" @touchmove="touchmoveClick">
  <div class="lv-msgbox-wrapper" style="position: absolute; z-index: 2001;">
    <div class="lv-msgbox">
      <div class="lv-msgbox-header">
        <div class="lv-msgbox-title">{{$t('feedback.tip')}}</div>
      </div>
      <div class="lv-msgbox-content">
        <div class="lv-msgbox-message">{{message}}</div>
      </div>
      <div class="lv-msgbox-btns">
        <button class="lv-msgbox-btn lv-msgbox-cancel" @click="cancel()">{{$t('feedback.cancel')}}</button>
        <button class="lv-msgbox-btn lv-msgbox-confirm" @click="confirm()">{{$t('feedback.ok')}}</button>
      </div>
    </div>
  </div>
  <div class="lv-modal" style="z-index: 2000;" @click="hideBg()"></div>
</div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  methods: {
    hideBg() {
      this.$emit('hide-click');
    },
    cancel() {
      this.$emit('cancel-click');
    },
    confirm() {
      this.$emit('confirm-click');
    },
    touchmoveClick(e) {
      // this.$emit('hide-click')
      e.stopPropagation();
      e.preventDefault();
    }
  }
}
</script>

<style lang="scss">
.myMassageBox {
    .lv-msgbox-wrapper {
        .lv-msgbox {
            position: fixed;
            top: 50%;
            left: 50%;
            -webkit-transform: translate3d(-50%, -50%, 0);
            transform: translate3d(-50%, -50%, 0);
            background-color: #fff;
            width: 85%;
            border-radius: 3px;
            font-size: 16px;
            -webkit-user-select: none;
            overflow: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transition: 0.2s;
            transition: 0.2s;
            .lv-msgbox-header {
                padding: 15px 0 0;
                .lv-msgbox-title {
                    text-align: center;
                    padding-left: 0;
                    margin-bottom: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: #333;
                }
            }
            .lv-msgbox-content {
                padding: 10px 20px 15px;
                border-bottom: 1px solid #ddd;
                min-height: 36px;
                position: relative;
                .lv-msgbox-message {
                    color: #999;
                    margin: 0;
                    text-align: center;
                    line-height: 36px;
                }
            }
            .lv-msgbox-btns {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                height: 40px;
                line-height: 40px;
                .lv-msgbox-btn {
                    line-height: 35px;
                    display: block;
                    background-color: #fff;
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    margin: 0;
                    border: 0;
                    font-size: 16px;
                    &.lv-msgbox-cancel {
                        width: 50%;
                        border-right: 1px solid #ddd;
                    }
                    &.lv-msgbox-confirm {
                        color: #26a2ff;
                        width: 50%;
                    }
                }

            }
        }
    }
    .lv-modal {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background: #000;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/vue/myMassageBox.vue